import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

import { grey } from "@mui/material/colors";
import { displayNewSignatureRequestForm, displayReadSignatureRequestForm } from "../../../../auto/js/forms/signatureRequest/NewSignatureRequestForm";
import { displaySignatureRequestList, signatureRequestListFields } from "../../../../auto/js/lists/signatureRequest/SignatureRequestList";
import { SIGNATURE_REQUEST_ORDER_BY_ID } from "../../../../auto/js/metadata/SignatureRequestOrderBy";
import { mapNnFieldto2ListView } from "../../Widgets/WidgetsFilters";
import { filterListViews } from "../../utils";
import { formState } from "../../../../auto/js/forms/FormState";
import { setContextualOptions } from "../../../../auto/js/widgets";
import { rest } from "../../../../auto/js/services";
import { getServiceUri } from "../../../../auto/js/metadata";
import { filter } from "lodash";
import { STATUS_PENDING } from "../../../../auto/js/metadata/Status";

export const getOrderBy = () => {
    return SIGNATURE_REQUEST_ORDER_BY_ID;
}

export const getRowActions = (rowData) => {
    return (
        <>
        <Tooltip>
            <IconButton 
                onClick={(event) => {
                    rowData.gui.goTo(displayReadSignatureRequestForm(() => displaySignatureRequestList(rowData.gui)), rowData.id)
                    if(rowData.status === STATUS_PENDING)
                        setPendingContext(rowData.gui, () => displaySignatureRequestList(rowData.gui));
                    else
                        setCompletedContext(rowData.gui, () => displaySignatureRequestList(rowData.gui));
                }}
                size="small"
                sx={{color: grey[900]}}
            >
                <VisibilityIcon />  
            </IconButton>
        </Tooltip>
        <Tooltip>
        <IconButton 
            onClick={(event) => {
                rest.delete('signature-request', rowData.id).then(() => displaySignatureRequestList(rowData.gui));
            }}
            size="small"
            sx={{color: grey[900]}}
        >
            <DeleteIcon />  
        </IconButton>
    </Tooltip>
    </>
    )
}

export const filterDataLogic = (defaultRows) => {
    const displayFilters = {};
    displayFilters["parties"] = mapNnFieldto2ListView;
    return filterListViews(defaultRows, signatureRequestListFields, displayFilters);
}

export const setPendingContext = (gui, onFinish) => {
    setContextualOptions({
        "signature-requests": {
            "requests": {
                submenu: {
                    "actions": {
                        options: {
                            sign: {label: "Sign", do: () => (onFinish)?sign(formState.getState().data.id).then(() => onFinish()):sign(formState.getState().data.id)},
                            reject: {label: "Reject", do: () => (onFinish)?reject(formState.getState().data.id).then(() => onFinish()):reject(formState.getState().data.id)}
                        },
                        label: "Actions"
                    },
                },
                label: "Signature Requests",
                do: (gui) => {
                    displaySignatureRequestList(gui);
                    setNewContext(gui);
                }
            }
        }
    })
}

export const setCompletedContext = (gui, onFinish) => {
    setContextualOptions({
        "signature-requests": {
            "requests": {
                submenu: {
                    "actions": {
                        options: {
                        },
                        label: ""
                    },
                },
                label: "Signature Requests",
                do: (gui) => displaySignatureRequestList(gui)
            }
        }
    })
}

export const setNewContext = (gui, onFinish) => {
    setContextualOptions({
        "signature-requests": {
            "requests": {
                submenu: {
                    "actions": {
                        options: {
                            new: {label: "New", do: (gui) => displayNewSignatureRequestForm(gui, () => { 
                            displaySignatureRequestList(gui)
                            setNewContext(gui);
                        })},
                        },
                        label: "Actions"
                    }
                },
                label: "Signature Requests",
                do: (gui) => { 
                            displaySignatureRequestList(gui)
                            setNewContext(gui);
                        }
            }
        }
    })
}

const sign = async (id) => {
    let dto = {signRequestId: id};
    return rest.request(getServiceUri() + 'signature-service/sign', 'POST', dto);
}
const reject = async (id) => {
    let dto = {signatureRequestId: id};
    return rest.request(getServiceUri() + 'signature-service/reject', 'POST', dto);
}

export const getDataEndpoint = async (filter) => {
    let searchEndpoint = "signature-request/custom-search-document/"
    return await rest.request(getServiceUri() + searchEndpoint, "POST", filter);
}

export const countDataEndpoint = async (filter) => {
    let countEndpoint = "signature-request/custom-count-document/"
    return await rest.request(getServiceUri() + countEndpoint, "POST", filter);
}